"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var FirstNetSignOnModelState_1 = require("./FirstNetSignOnModelState");
var styles = require("./FirstNetSignOnModel.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var CartConfiguration_scss_1 = require("../CartConfiguration.scss");
var customer_verification_modal_1 = require("@sales/customer-verification-modal");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var WirelessUtilFunctions_1 = require("../../../utils/WirelessUtilFunctions");
var icons = require("../../../styles/ccc-icons-cart.scss");
var ReportingService_1 = require("../../../api/ReportingService");
var FirstNetSignOnModel = /** @class */ (function (_super) {
    __extends(FirstNetSignOnModel, _super);
    function FirstNetSignOnModel(props) {
        var _this = _super.call(this, props) || this;
        _this.firelinkAnalytics = function (e) {
            _this.reportingService.fireLinkClickWithOutDestination(e);
        };
        _this.fireModalAnalytics = function () {
            _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.FIRSTNET_IDENTITY_MODAL);
        };
        _this.state = new FirstNetSignOnModelState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.redirectToBuyFlow = _this.redirectToBuyFlow.bind(_this);
        _this.showFirstNetVerificationModal = _this.showFirstNetVerificationModal.bind(_this);
        _this.handleFnVerificationModal = _this.handleFnVerificationModal.bind(_this);
        _this.displayFaiureMessage = _this.displayFaiureMessage.bind(_this);
        _this.reportButtonEvent = _this.reportButtonEvent.bind(_this);
        return _this;
    }
    FirstNetSignOnModel.prototype.render = function () {
        var _this = this;
        this.cartSummaryCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common
            .cartConfiguration;
        var failureIcon = [icons.cccIconCart, icons.cccIconCartLg, icons.cccIconCartBadgealert,
            styles.redColorText].join(' ');
        return (React.createElement(React.Fragment, null,
            !this.state.isVerificationFailure &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.fnAlmostDone },
                        React.createElement("span", null, this.cartSummaryCMSData.firstNetInfo)),
                    React.createElement("div", { className: styles.fnSubText },
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('Cart', 'Firstnet Verification', 'label'), data: { text: this.cartSummaryCMSData.firstNetVerificationInfo } })),
                    React.createElement("div", { className: styles.fnVerificationButton },
                        React.createElement(ui_components_1.Button, { data: { text: this.cartSummaryCMSData.firstNetVerificationBtn }, events: { onClick: function () { return _this.handleFnVerificationModal(true); } }, options: { className: styles.buttonSize }, testId: utils_1.default('Button', this.cartSummaryCMSData.firstNetVerificationBtn) })),
                    React.createElement("div", { className: styles.fnSubText },
                        React.createElement(ui_components_1.Label, { testId: utils_1.default('Cart', 'Firstnet Verification', 'label'), data: { text: this.cartSummaryCMSData.firstNetGoBack } }),
                        React.createElement("span", { className: styles.underline, onClick: this.redirectToBuyFlow }, this.cartSummaryCMSData.firstNetGoBackLink))),
            this.state.isVerificationFailure &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: styles.failureBackground },
                        React.createElement("div", { className: styles.inlineFlex },
                            React.createElement("i", { className: failureIcon, role: "img", "aria-label": "firstnet-failure" }),
                            React.createElement(ui_components_1.Label, { testId: utils_1.default('Cart', 'Firstnet Failure', 'label'), data: { text: this.cartSummaryCMSData.firstNetFailureText }, options: { className: styles.failureText } })),
                        React.createElement("div", { className: styles.fnVerificationButton },
                            React.createElement(ui_components_1.Button, { data: { text: this.cartSummaryCMSData.firstNetFailureBtnText }, events: { onClick: this.redirectToBuyFlow }, options: { className: styles.failureButton }, testId: utils_1.default('Button', this.cartSummaryCMSData.firstNetFailureBtnText) })))),
            this.showFirstNetVerificationModal()));
    };
    FirstNetSignOnModel.prototype.displayFaiureMessage = function () {
        this.setState({ isVerificationFailure: true, isVerificationModalOpen: false });
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
    };
    FirstNetSignOnModel.prototype.reportButtonEvent = function () {
        this.reportingService.fireLinkClickEvent('See if I\'m eligible', ReportingService_1.PageUrls.FIRSTNET_MODAL);
        this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.FIRSTNET_MODAL);
    };
    FirstNetSignOnModel.prototype.redirectToBuyFlow = function () {
        this.props.onEdit('Wireless', WirelessUtilFunctions_1.getEditUrlForFirstNet());
    };
    FirstNetSignOnModel.prototype.showFirstNetVerificationModal = function () {
        var _this = this;
        if (this.state.isVerificationModalOpen) {
            return (React.createElement(ui_components_1.Modal, { testId: "Modal_SeeFirstNet_Verification", options: { className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.isVerificationModalOpen, showClose: true }, events: { onClose: function () { return _this.handleFnVerificationModal(false); } }, accessibilityText: "_SeeFirstNet_Verification" },
                React.createElement("div", { className: styles.modalSize },
                    React.createElement(customer_verification_modal_1.CustomerVerification, { applicationUrl: window.location.href, closeModal: this.handleFnVerificationModal.bind(this, false), handleFailureContinue: this.displayFaiureMessage, handleVerificationCta: this.reportButtonEvent, showFirstNetVerifyCTA: true, onLinkClick: this.firelinkAnalytics, modalPageLoadEvent: this.fireModalAnalytics }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    FirstNetSignOnModel.prototype.handleFnVerificationModal = function (display) {
        this.setState({ isVerificationModalOpen: display });
    };
    return FirstNetSignOnModel;
}(React.Component));
exports.default = FirstNetSignOnModel;
//# sourceMappingURL=FirstNetSignOnModel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/FirstNetSignOnModel/FirstNetSignOnModel.js
// module id = 799
// module chunks = 8